import React from 'react';
import Moment from 'react-moment';

import { useFleet } from '../../hooks/useFleet';
import { CustomerOnly, InternalOnly } from './adminOnly';
import { timezonesEnum } from '../../utils';
import { dateFormats } from '../../constants';

interface Props {
  children: string;
}

export function Time(props: Props) {
  const fleet = useFleet();
  const timezone = fleet.timezone ?? timezonesEnum.AMERICA_NEW_YORK;

  return (
    <>
      <InternalOnly>
        <Moment tz={timezone} format={dateFormats.timeWithSeconds}>
          {props.children}
        </Moment>
      </InternalOnly>

      <CustomerOnly>
        <Moment tz={timezone} format={dateFormats.time}>
          {props.children}
        </Moment>
      </CustomerOnly>
    </>
  );
}
